<template>
  <el-dialog
    :title="formData && formData.id ? $t('components.CreateOrderDialog.939026-0') : $t('components.CreateOrderDialog.939026-1')"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    :append-to-body="true"
    @close="handleClose"
  >
    <el-form ref="orderForm" :model="form" :rules="rules" label-width="120px" label-position="right">
      <el-form-item :label="$t('components.CreateOrderDialog.939026-2')" prop="orderNo">
        <el-input v-model="form.orderNo" :placeholder="$t('components.CreateOrderDialog.939026-3')" :disabled="!!formData && !!formData.id" />
      </el-form-item>

      <el-form-item :label="$t('components.CreateOrderDialog.939026-4')" prop="uId">
        <el-select
          v-model="form.uId"
          filterable
          remote
          :remote-method="handleUserSearch"
          v-el-select-loadmore="handleUserLoadMore"
          :loading="userLoading"
          :placeholder="$t('components.CreateOrderDialog.939026-5')"
          style="width: 100%"
          @change="handleUserChange"
        >
          <el-option v-for="item in userOptions" :key="item.id" :label="item.userName" :value="item.id" />
          <li v-if="userLoadingMore" class="el-select-dropdown__item is-disabled select-loading-more">
            <i class="el-icon-loading"></i> {{ $t("common.loading") }}
          </li>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('components.CreateOrderDialog.939026-6')" prop="teamIds">
        <el-select
          v-model="form.teamIds"
          multiple
          filterable
          :loading="teamLoading"
          :placeholder="$t('components.CreateOrderDialog.939026-7')"
          style="width: 100%"
        >
          <el-option v-for="item in teamOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('components.CreateOrderDialog.939026-8')">
        <el-input v-model="form.notes" type="textarea" :rows="4" :placeholder="$t('components.CreateOrderDialog.939026-9')" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">{{ $t('components.CreateOrderDialog.939026-10') }}</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting" size="small">
        {{ $t('components.CreateOrderDialog.939026-11') }}{{ formData && formData.id ? $t('components.CreateOrderDialog.939026-12') : $t('components.CreateOrderDialog.939026-1') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "CreateOrderDialog",
    directives: {
      "el-select-loadmore": {
        // 下拉滚动触底加载自定义指令
        bind(el, binding) {
          const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
          SELECTWRAP_DOM.addEventListener("scroll", function () {
            const condition = this.scrollHeight - this.scrollTop - 15 <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      formData: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        dialogVisible: false,
        submitting: false,
        userLoading: false,
        userLoadingMore: false,
        teamLoading: false,
        form: {
          id: "",
          orderNo: "",
          uId: "",
          teamIds: [],
          notes: ""
        },
        rules: {
          orderNo: [{ required: true, message: this.$t('components.CreateOrderDialog.939026-3'), trigger: "blur" }],
          uId: [{ required: true, message: this.$t('components.CreateOrderDialog.939026-13'), trigger: "change" }]
        },
        userOptions: [],
        userPage: {
          pageIndex: 1,
          pageSize: 20,
          pages: 1
        },
        userKeyword: "",
        userSearchTimer: null,
        userReqSeq: 0,
        teamOptions: []
      };
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
        if (val) {
          this.userKeyword = "";
          this.loadUsers(true).then(() => {
            this.initForm();
          });
        }
      },
      dialogVisible(val) {
        this.$emit("update:visible", val);
      }
    },
    beforeDestroy() {
      if (this.userSearchTimer) {
        clearTimeout(this.userSearchTimer);
        this.userSearchTimer = null;
      }
    },
    methods: {
      // 加载用户列表（分页接口 user/select）
      loadUsers(reset = false) {
        if (reset) {
          this.userPage.pageIndex = 1;
          this.userPage.pages = 1;
          this.userLoading = true;
        } else {
          if (this.userLoading || this.userLoadingMore) {
            return Promise.resolve();
          }
          this.userLoadingMore = true;
        }
        const params = {
          pageIndex: this.userPage.pageIndex,
          pageSize: this.userPage.pageSize
        };
        if (this.userKeyword) {
          params.userName = this.userKeyword;
        }
        const seq = ++this.userReqSeq;
        return this.$api
          .request(this.$url.User.selectUser, this.$method.get, params)
          .then(res => {
            if (seq !== this.userReqSeq) {
              return;
            }
            if (res.code === 0 && res.data) {
              const records = Array.isArray(res.data.records) ? res.data.records : [];
              this.userPage.pages = parseInt(res.data.pages, 10) || 1;
              if (this.userPage.pageIndex === 1) {
                this.userOptions = records;
              } else {
                this.userOptions = this.userOptions.concat(records);
              }
              this.ensureSelectedUserOption();
            } else {
              this.$message.error(res.msg || this.$t('components.CreateOrderDialog.939026-14'));
            }
          })
          .catch(err => {
            if (seq !== this.userReqSeq) {
              return;
            }
            this.$message.error(this.$t('components.CreateOrderDialog.939026-14'));
            console.error(err);
          })
          .finally(() => {
            if (seq === this.userReqSeq) {
              this.userLoading = false;
              this.userLoadingMore = false;
            }
          });
      },

      // 远程搜索用户（防抖 300ms）
      handleUserSearch(query) {
        this.userKeyword = (query || "").trim();
        if (this.userSearchTimer) {
          clearTimeout(this.userSearchTimer);
        }
        this.userSearchTimer = setTimeout(() => {
          this.loadUsers(true);
        }, 300);
      },

      // 下拉滚动触底加载下一页
      handleUserLoadMore() {
        if (this.userLoading || this.userLoadingMore) {
          return;
        }
        if (this.userPage.pageIndex >= this.userPage.pages) {
          return;
        }
        this.userPage.pageIndex++;
        this.loadUsers();
      },

      // 确保当前选中用户在选项中（分页加载时可能不在当前页）
      ensureSelectedUserOption() {
        const uid = this.form.uId;
        if (!uid || this.userOptions.some(item => item.id === uid)) {
          return;
        }
        const userName = (this.formData && this.formData.userName) || uid;
        this.userOptions.unshift({ id: uid, userName });
      },

      // 初始化表单
      initForm() {
        // 加载分组列表
        this.loadUserTeams();

        if (this.formData && this.formData.id) {
          // 编辑模式
          this.form = {
            id: this.formData.id,
            orderNo: this.formData.orderNo || "",
            uId: this.formData.uId || this.formData.insertUid || "",
            teamIds: this.formData.teamIds || [],
            notes: this.formData.notes || ""
          };
          this.ensureSelectedUserOption();
        } else {
          // 创建模式
          this.form = {
            id: "",
            orderNo: "",
            uId: "",
            teamIds: [],
            notes: ""
          };
        }
        this.$nextTick(() => {
          if (this.$refs.orderForm) {
            this.$refs.orderForm.clearValidate();
          }
        });
      },

      // 用户改变
      handleUserChange() {
        // 用户改变时不需要重新加载分组，因为分组列表已经全量加载了
      },

      // 加载分组列表
      loadUserTeams() {
        this.teamLoading = true;
        this.$api
          .request(this.$url.MachineGroup.list, this.$method.get)
          .then(res => {
            if (res.code === 0) {
              this.teamOptions = Array.isArray(res.data) ? res.data : [];
            } else {
              this.$message.error(res.msg || this.$t('components.CreateOrderDialog.939026-15'));
              this.teamOptions = [];
            }
          })
          .catch(err => {
            console.error(err);
            this.$message.error(this.$t('components.CreateOrderDialog.939026-15'));
            this.teamOptions = [];
          })
          .finally(() => {
            this.teamLoading = false;
          });
      },

      // 提交
      handleSubmit() {
        this.$refs.orderForm.validate(valid => {
          if (valid) {
            this.submitting = true;
            const url = this.form.id ? this.$url.ShippingOrder.update : this.$url.ShippingOrder.insert;
            const method = this.form.id ? this.$method.put : this.$method.post;
            const data = {
              orderNo: this.form.orderNo,
              uId: this.form.uId,
              teamIds: this.form.teamIds,
              notes: this.form.notes
            };
            if (this.form.id) {
              data.id = this.form.id;
            }

            this.$api
              .request(url, method, data)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.form.id ? this.$t('components.CreateOrderDialog.939026-16') : this.$t('components.CreateOrderDialog.939026-17'));
                  this.$emit("success");
                  this.handleClose();
                } else {
                  this.$message.error(res.msg || this.$t('components.CreateOrderDialog.939026-18'));
                }
              })
              .catch(err => {
                this.$message.error(this.$t('components.CreateOrderDialog.939026-19'));
                console.error(err);
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        });
      },

      // 关闭
      handleClose() {
        this.dialogVisible = false;
        this.form = {
          id: "",
          orderNo: "",
          uId: "",
          teamIds: [],
          notes: ""
        };
        this.userOptions = [];
        this.teamOptions = [];
        this.userKeyword = "";
        this.userLoadingMore = false;
        this.userPage = { pageIndex: 1, pageSize: 20, pages: 1 };
        if (this.userSearchTimer) {
          clearTimeout(this.userSearchTimer);
          this.userSearchTimer = null;
        }
        if (this.$refs.orderForm) {
          this.$refs.orderForm.clearValidate();
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .dialog-footer {
    text-align: right;
  }

  .select-loading-more {
    text-align: center;
    color: #909399;
  }
</style>
